window.theme = window.theme || {};

window.theme.marketMoney = {
  defaultFormats: {
    EUR: { template: '€ {{amount}}', thousands: '.', decimal: ',' },
    SEK: { template: '{{amount}} kr', thousands: ' ', decimal: ',' },
    DKK: { template: '{{amount}} kr.', thousands: '.', decimal: ',' },
    NOK: { template: '{{amount}} kr', thousands: ' ', decimal: ',' },
    PLN: { template: '{{amount}} zł', thousands: '.', decimal: ',' },
    // AAS-5460 — one CHF format for every Swiss language; see format-money.liquid.
    CHF: { template: 'CHF {{amount}}', thousands: "'", decimal: '.' },
    GBP: { template: '£{{amount}}', thousands: ',', decimal: '.' },
    CZK: { template: '{{amount}} Kč', thousands: ' ', decimal: ',' },
    USD: { template: '${{amount}}', thousands: ',', decimal: '.' },
    CAD: { template: '${{amount}}', thousands: ',', decimal: '.' },
    'CAD:fr': { template: '{{amount}} $', thousands: ' ', decimal: ',' },
  },

  // AAS-4164 catalog-only market — killswitch, mirrors snippets/format-money.liquid.
  // Reads the <html> class rather than window.theme.market.handle: js-variables.liquid
  // renders at the end of <body>, so window.theme.market is not guaranteed to exist
  // by the time this asset runs.
  isCatalogMarket() {
    return document.documentElement.classList.contains('market--catalog');
  },

  getFormatOverrides() {
    const settings = window.theme?.settings || {};

    if (settings.market_money_formats && Object.keys(settings.market_money_formats).length > 0) {
      return settings.market_money_formats;
    }

    try {
      return JSON.parse(settings.market_money_formats_json || '{}');
    } catch (error) {
      console.warn('Invalid Market money format overrides JSON', error);
      return {};
    }
  },

  getFormatKeys() {
    const market = window.theme?.market || {};
    const marketHandle = market.handle;
    const currencyCode = market.currency_code;
    const locale = market.locale || window.Shopify?.locale || '';
    const language = locale.split('-')[0];

    return [
      marketHandle && locale && `${marketHandle}:${locale}`,
      marketHandle && language && `${marketHandle}:${language}`,
      currencyCode && locale && `${currencyCode}:${locale}`,
      currencyCode && language && `${currencyCode}:${language}`,
      marketHandle,
      currencyCode,
    ].filter(Boolean);
  },

  getFormatConfig() {
    const settings = window.theme?.settings || {};
    const market = window.theme?.market || {};
    const marketFormats = this.getFormatOverrides();
    const formatKeys = this.getFormatKeys();

    for (const key of formatKeys) {
      if (marketFormats[key]) return marketFormats[key];
      if (this.defaultFormats[key]) return this.defaultFormats[key];
    }

    return (
      market.money_format ||
      settings.market_money_format ||
      settings.money_with_currency_format ||
      settings.money_format ||
      '${{amount}}'
    );
  },

  getFormat() {
    const formatConfig = this.getFormatConfig();

    if (typeof formatConfig === 'string') {
      return formatConfig;
    }

    return formatConfig.template || '${{amount}}';
  },

  format(cents, format) {
    if (this.isCatalogMarket()) return '';

    const formatConfig = format || this.getFormatConfig();

    if (typeof formatConfig === 'object') {
      return this.formatWithConfig(cents, formatConfig);
    }

    const moneyFormat = formatConfig;

    if (typeof window.formatMoney === 'function') {
      return window.formatMoney(cents, moneyFormat);
    }

    const market = window.theme?.market || {};
    const locale = market.locale || window.Shopify?.locale || 'en';
    const currency = market.currency_code || window.Shopify?.currency?.active || 'GBP';

    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
    }).format((Number(cents) || 0) / 100);
  },

  // Guarded independently of format() — callers reach this directly.
  formatWithConfig(cents, config) {
    if (this.isCatalogMarket()) return '';

    const amount = this.formatAmount(cents, config);
    const template = config.template || '{{amount}}';

    return template.replace(/\{\{\s*amount\s*\}\}/g, amount);
  },

  formatAmount(cents, config) {
    const precision = typeof config.precision === 'number' ? config.precision : 2;
    const decimal = config.decimal ?? '.';
    const thousands = config.thousands ?? ',';
    const value = (Number(cents) || 0) / 100;
    const sign = value < 0 ? '-' : '';
    const [integerPart, decimalPart] = Math.abs(value).toFixed(precision).split('.');
    const groupedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);

    return `${sign}${groupedInteger}${precision > 0 ? decimal + decimalPart : ''}`;
  },

  stripHtml(value) {
    const element = document.createElement('div');
    element.innerHTML = value;
    return (element.textContent || element.innerText || '').trim();
  },
};
